var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayedColors.length > 1
    ? _c(
        "div",
        {
          class: [
            _vm.bemBlock,
            "base-color-swatches",
            {
              "visually-hidden": _vm.visuallyHidden
            }
          ]
        },
        [
          _c(
            "ul",
            {
              class: [
                _vm.bemElement("color-container"),
                "base-color-swatches__color-container"
              ]
            },
            _vm._l(_vm.displayedColors, function(color, index) {
              return _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: color.displayed,
                      expression: "color.displayed"
                    }
                  ],
                  key: index,
                  class: [_vm.bemElement("item"), "base-color-swatches__item"],
                  attrs: { "data-attr": "color" }
                },
                [
                  _c(
                    "button",
                    {
                      class: [
                        _vm.bemElement("swatch", {
                          selected: _vm.isColorSelected(color)
                        }),
                        "base-color-swatches__swatch",
                        _vm.isColorSelected(color)
                          ? "base-color-swatches__swatch--selected"
                          : ""
                      ],
                      attrs: { "data-url": color.url },
                      on: {
                        click: function($event) {
                          return _vm.handleSelectColor(color, $event)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "visually-hidden" }, [
                        _vm._v(_vm._s(color.displayedValue))
                      ]),
                      _vm._v(" "),
                      _vm.hasSwatchImage(color)
                        ? _c("img", {
                            class: [
                              _vm.bemElement("swatch-img"),
                              "base-color-swatches__swatch-display",
                              {
                                loading: _vm.loadingImage
                              }
                            ],
                            attrs: {
                              alt: _vm.getSwatchImage(color).alt,
                              src: _vm.getSwatchImage(color).url
                            },
                            on: {
                              error: _vm.handleImageError,
                              load: _vm.isImageLoaded
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.overflowMaxColors
            ? _c("button", {
                class: [
                  _vm.bemElement(_vm.expanded ? "shrink" : "expand"),
                  _vm.expanded ? "btn-minus" : "btn-plus",
                  _vm.expanded
                    ? "base-color-swatches__shrink"
                    : "base-color-swatches__expand"
                ],
                on: { click: _vm.toggleExtended }
              })
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }